import { useLayoutEffect } from 'react';
import { useMediaQ } from './useMediaQ';

export function useScrollFreeze() {
    const query = useMediaQ('min', 1024);

    useLayoutEffect(() => {
        //   set value to hidden if component has mounted
        const scrollContainer = document.querySelector('#scroll-container');

        if (scrollContainer) {
            if (query) {
                const clientWidth = scrollContainer?.clientWidth;
                const offsetWidth = scrollContainer?.offsetWidth;
                const scrollBarWidth = offsetWidth - clientWidth;

                scrollContainer.style.overflow = 'hidden';
                scrollContainer.style.paddingRight = `${scrollBarWidth}px`;
            }

            if (!query) {
                const clientWidth = document.body?.clientWidth;
                const offsetWidth = document.body?.offsetWidth;
                const scrollBarWidth = offsetWidth - clientWidth;

                document.body.style.overflow = 'hidden';
                document.body.style.paddingRight = `${scrollBarWidth}px`;
            }

            // return value to visible if component is unmounted
            return () => {
                scrollContainer.style.overflow = 'auto';
                document.body.style.overflow = 'initial';
                scrollContainer.style.paddingRight = 'initial';
                document.body.style.paddingRight = 'initial';
            };
        }
    }, [query]);
}
